import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const DatenschutzPage = () => {
  return (
    <div className="min-h-screen">
      <div className="max-w-3xl mx-auto px-4 py-12">
        <Link to="/register" className="inline-flex items-center gap-1 text-sm text-emerald-600 hover:text-emerald-700 mb-8 dark:text-emerald-400">
          <ArrowLeft size={16} /> Zurück zur Registrierung
        </Link>

        <h1 className="text-3xl font-bold text-gray-900 mb-2 dark:text-gray-100">Datenschutzerklärung</h1>
        <p className="text-sm text-gray-500 mb-8 dark:text-gray-400">Stand: Juni 2026 | PredFuture | Gemäß DSGVO</p>

        <div className="prose prose-gray max-w-none space-y-6 text-gray-700 text-[15px] leading-relaxed dark:text-gray-300">
          <section>
            <h2 className="text-lg font-semibold text-gray-900 mt-8 mb-3 dark:text-gray-100">1. Verantwortlicher</h2>
            <p>
              Verantwortlicher im Sinne der Datenschutz-Grundverordnung (DSGVO) ist:<br />
              hobeco UG (haftungsbeschränkt)<br />
              Am Ackerrain 14, 50933 Köln<br />
              E-Mail: dev@hobeco.one
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mt-8 mb-3 dark:text-gray-100">2. Erhebung und Speicherung personenbezogener Daten</h2>
            <p>
              Bei der Registrierung erheben wir folgende Daten:
            </p>
            <ul className="list-disc ml-6 space-y-1">
              <li>E-Mail-Adresse</li>
              <li>Benutzername (selbst gewählt)</li>
              <li>Passwort (verschlüsselt gespeichert)</li>
              <li>Zeitpunkt der Registrierung</li>
              <li>Leaderboard-Präferenz (Opt-in)</li>
            </ul>
            <p className="mt-3">
              Bei der Nutzung der Plattform werden zusätzlich gespeichert:
            </p>
            <ul className="list-disc ml-6 space-y-1">
              <li>Wettverläufe und Transaktionen (virtuelle Credits)</li>
              <li>Zeitstempel der Aktivitäten</li>
              <li>Login-/Logout-Ereignisse mit IP-Adresse, User-Agent (Browser-Kennung) und – sofern auflösbar – grober Standort (Land/Stadt, ermittelt via ipapi.co)</li>
              <li>Bei aktiviertem Fehler-Tracking (Sentry): technische Stack-Traces, ohne personenbezogene Inhalte (PII-Filter aktiv)</li>
              <li>Während der Showcase-Beta: Credit-„Käufe" laufen im Test-Modus, es werden keine echten Zahlungsdaten erhoben oder verarbeitet</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mt-8 mb-3 dark:text-gray-100">2a. Auftragsverarbeiter und Drittdienste</h2>
            <p>Folgende Dienste verarbeiten Daten in unserem Auftrag:</p>
            <ul className="list-disc ml-6 space-y-1">
              <li><strong>Sentry</strong> (Sentry Inc., USA) – Fehler-Tracking. AV-Vertrag liegt vor, EU-Standardvertragsklauseln. Stack-Traces werden mit PII-Filter aufgenommen.</li>
              <li><strong>ipapi.co</strong> – Auflösung von IP-Adressen zu grobem Standort (Land/Stadt) für Audit-Trail-Zwecke. Anfragen erfolgen serverseitig.</li>
              <li><strong>Hosting</strong> – Railway (Railway Corp., USA). Deployment in einer EU-Region vorgesehen; AV-Vertrag und ggf. EU-Standardvertragsklauseln werden vor Go-Live abgeschlossen.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mt-8 mb-3 dark:text-gray-100">3. Rechtsgrundlage der Verarbeitung</h2>
            <p>
              Die Verarbeitung der personenbezogenen Daten erfolgt auf Grundlage von:
            </p>
            <ul className="list-disc ml-6 space-y-1">
              <li><strong>Art. 6 Abs. 1 lit. a DSGVO</strong> — Einwilligung (Leaderboard-Sichtbarkeit)</li>
              <li><strong>Art. 6 Abs. 1 lit. b DSGVO</strong> — Vertragserfüllung (Bereitstellung der Plattform)</li>
              <li><strong>Art. 6 Abs. 1 lit. f DSGVO</strong> — Berechtigtes Interesse (Sicherheit, Missbrauchsprävention)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mt-8 mb-3 dark:text-gray-100">4. Zweck der Datenverarbeitung</h2>
            <p>Wir verwenden Ihre Daten ausschließlich für:</p>
            <ul className="list-disc ml-6 space-y-1">
              <li>Bereitstellung und Betrieb der Plattform</li>
              <li>Verwaltung Ihres Nutzerkontos</li>
              <li>Abrechnung von Wetten und virtuellen Credits</li>
              <li>Anzeige im öffentlichen Leaderboard (nur bei ausdrücklicher Einwilligung)</li>
              <li>Sicherheit und Missbrauchsprävention</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mt-8 mb-3 dark:text-gray-100">5. Speicherdauer</h2>
            <p>
              Personenbezogene Daten werden so lange gespeichert, wie Ihr Nutzerkonto aktiv ist.
              Nach Löschung des Kontos werden die Daten innerhalb von 30 Tagen gelöscht,
              sofern keine gesetzlichen Aufbewahrungspflichten bestehen.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mt-8 mb-3 dark:text-gray-100">6. Ihre Rechte nach DSGVO</h2>
            <p>Sie haben jederzeit folgende Rechte:</p>
            <ul className="list-disc ml-6 space-y-1">
              <li><strong>Auskunft</strong> (Art. 15 DSGVO) — Welche Daten über Sie gespeichert sind</li>
              <li><strong>Berichtigung</strong> (Art. 16 DSGVO) — Korrektur unrichtiger Daten</li>
              <li><strong>Löschung</strong> (Art. 17 DSGVO) — Löschung Ihrer Daten („Recht auf Vergessenwerden")</li>
              <li><strong>Einschränkung</strong> (Art. 18 DSGVO) — Einschränkung der Verarbeitung</li>
              <li><strong>Datenübertragbarkeit</strong> (Art. 20 DSGVO) — Export Ihrer Daten</li>
              <li><strong>Widerspruch</strong> (Art. 21 DSGVO) — Widerspruch gegen die Verarbeitung</li>
              <li><strong>Widerruf der Einwilligung</strong> (Art. 7 Abs. 3 DSGVO) — Jederzeit mit Wirkung für die Zukunft</li>
            </ul>
            <p className="mt-3">
              Zur Ausübung Ihrer Rechte kontaktieren Sie uns unter: dev@hobeco.one
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mt-8 mb-3 dark:text-gray-100">7. Beschwerderecht</h2>
            <p>
              Sie haben das Recht, sich bei einer Datenschutz-Aufsichtsbehörde über die Verarbeitung
              Ihrer personenbezogenen Daten zu beschweren.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mt-8 mb-3 dark:text-gray-100">8. Cookies und Tracking</h2>
            <p>
              Die Plattform verwendet ausschließlich technisch notwendige Cookies (Session-Token, Einstellungen).
              Es werden keine Tracking- oder Analyse-Cookies eingesetzt. Es erfolgt kein Profiling.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mt-8 mb-3 dark:text-gray-100">9. Datensicherheit</h2>
            <p>
              Wir setzen technische und organisatorische Maßnahmen ein, um Ihre Daten vor unbefugtem Zugriff,
              Verlust oder Manipulation zu schützen. Passwörter werden ausschließlich als kryptographische
              Hashes gespeichert. Die Datenübertragung erfolgt verschlüsselt über HTTPS.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mt-8 mb-3 dark:text-gray-100">10. Änderungen dieser Datenschutzerklärung</h2>
            <p>
              Wir behalten uns vor, diese Datenschutzerklärung zu aktualisieren. Änderungen werden auf
              der Plattform veröffentlicht. Die aktuelle Version gilt ab dem angegebenen Stand.
            </p>
          </section>
        </div>

        <div className="mt-12 pt-6 border-t border-gray-200 text-xs text-gray-400 dark:border-slate-700 dark:text-gray-500">
          <p>hobeco UG (haftungsbeschränkt) | Am Ackerrain 14, 50933 Köln | dev@hobeco.one</p>
        </div>
      </div>
    </div>
  );
};

export default DatenschutzPage;
